<template>
    <div id="main">
        <loader v-if="isLoading"/>
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs"/>

            <div class="novo-categoria">
                <!-- TÍTULO -->
                <h1 class="title">{{ $t('categorias') }}{{ categoria.idcategoria != null ?  `: ${categoria.descricao}` : `: ${$t('nova-categoria')}` }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a class="a-inativo">{{$t('vendas')}}</a></li>
                        <li><a class="a-inativo">{{$t('cadastros')}}</a></li>
                        <li><a @click="$router.push({ name: 'ven-categoria-list' })">{{$t('categorias')}}</a></li>
                        <li><a aria-current="page">{{ categoria.idcategoria != null ? categoria.descricao : $t('nova-categoria') }}</a></li>
                    </ul>
                </nav>

                <!-- FORMULÁRIO -->
                <div class="mt-5">
                    <div class="form-columns-fit">
                        <!-- DESCRIÇÃO -->
                        <div class="columns is-flex-wrap">
                            <div class="column is-3">
                                <v-input 
                                    :id="generateId(1)"
                                    ref="idErpInput"
                                    v-model="categoria.idcategoriaerp"
                                    placeholder="placeholder-preencha"
                                    :maxlength="30"
                                    title="codigo"
                                    uppercase
                                    required
                                    tooltipLabel="cod-ref"
                                    :invalid="!categoria.idcategoriaerp"
                                    :disabled="usuarioIntegracao"
                                />
                            </div>
                            <div class="descricao-input column is-9">
                                <v-input
                                    :id="generateId(2)"
                                    ref="descricaoInput"
                                    v-model="categoria.descricao"
                                    placeholder="descricao-categoria-placeholder"
                                    :maxlength="50"
                                    :title="'descricao'"
                                    :required="true"
                                    :msg="'msg-campo-obrigatorio'"
                                    :invalid="!categoria.descricao"
                                    uppercase
                                    tooltipLabel="info-descricao-generica"
                                    :disabled="usuarioIntegracao"
                                />
                            </div>
    
                            <!-- SITUAÇÃO -->
                            <div class="situacao-input column is-3">
                                <vss-select
                                    :id="generateId(3)"
                                    ref="situacaoSelect" 
                                    :options="situacoes" 
                                    v-model="categoria.situacao" 
                                    :mlLabels="true"
                                    class="no-clear"
                                    title="situacao"
                                    tooltipLabel="info-situacao-generica"
                                    :disabled="usuarioIntegracao"
                                />
                            </div>
                            <div class="categoria-input column is-9">
                                <vs-select
                                    :id="generateId(4)"
                                    ref="categoriaSelect"
                                    :title="'categoriapai'"
                                    :options="categorias"
                                    v-model="categoria.categoriapai"
                                    :search="loadCategoria"
                                    :onChange="updateCategoria"
                                    :getOptionLabel="getLabel"
                                    :placeholder="'selecione'"
                                    tooltipLabel="info-categoria-pai"
                                    :disabled="usuarioIntegracao"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- BOTÕES -->
                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="$router.push({name: 'ven-categoria-list'})">
                        {{ $t('voltar') }}
                    </button>
                    <button v-if="(allowedUpdateCategoria || allowedCreateCategoria) && !usuarioIntegracao" 
                        class="save-btn" 
                        type="button" 
                        @click="saveCategoria" 
                        :disabled="isSaving">
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import ImgPicker from "@/components/shared/form/ImgPicker.vue";
import FilterBar from "@/components/shared/Filter";
import CategoriaService from "@/services/CategoriaService";
import CategoriaValidation from "@/services/validations/CategoriaValidation";
import Message from "@/models/Message";

export default {
    components: {
        FilterBar,
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes("CATEGORIA"),
            canSelectCategoria: false,
            isLoading: false,
            categorias: [],
            categoria: {
                id: null,
                idcategoriaerp: null,
                descricao: null,
                situacao: null,
                categoriapai: null,
            },
            service: new CategoriaService(this.$http, this.$router),
            msgs: [],
            isSaving: false,
            situacoes: [{ label: "inativo", id: 0 }, { label: "ativo", id: 1 }],
            validation: null,
            permissao: {},
            isUpdate: false,
            isEdit: false
        };
    },
    computed: {
        allowedUpdateCategoria() {
            return this.isUpdate
                && this.permissao.update;
        },
        allowedCreateCategoria() {
            return !this.isUpdate
                && this.permissao.create;
        },
    },
    created() {
        this.isUpdate = this.$route.params.name != null
            && this.$route.params.name != 'ven-categoria-new';
        
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-categoria');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'categoria' },
        });
        
        (!this.isUpdate && !this.allowedCreateCategoria) && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'categoria' },
        });

        this.service = new CategoriaService(this.$http, this.$router);
        this.validation = new CategoriaValidation(this.msgs);

        if (this.$route.params.id && this.$route.params.name != 'ven-categoria-new') {
            this.isEdit = true
            this.carregarDados(this.$route.params.id);
        } else {
            this.loadCategoria()
            this.categoria.situacao = this.situacoes[1];
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name+'-'+numberId;
        },
        carregarDados (id) {
            this.isLoading = true;

            this.service.find(id)
                .then(body => {
                    if (body.content != null) {
                        this.categoria = this.mapOnSave(body.content)
                        if (body.content.situacao in [0, 1]) {
                            this.categoria.situacao = this.situacoes[body.content.situacao];
                        } else {
                            console.warn(`ID de situação inválido ao carregar categoria: ${body.content.situacao}`);
                            this.categoria.situacao = this.situacoes[1];
                        }
                    }
                })
                .catch(e => {
                    console.error(e);

                    this.msgs.push(
                        new Message("error", 'msg-erro-load-categoria', true)
                    );
                })
                .finally(() => {
                    this.loadCategoria()
                    this.isLoading = false;
                });
        },
        loadCategoria(value = ".*") {
            this.service
                .findAllCombo(0, value ? value : "")
                .then(this.mapItems)
                .then(allCategoria => {
                    this.categorias = allCategoria;
                    this.categorias.unshift(this.categoriaVazia())
                    this.categorias = this.isEdit
                        ? this.categorias.filter((item) => item.idcategoria !== this.categoria.idcategoria) 
                        : this.categorias

                    if (!this.categoria.categoriapai) {
                        this.categoria.categoriapai = this.categorias[0];
                    }
                }, 350);
        },
        updateCategoria(categoriaPai) {
            if (categoriaPai) {
                this.categoria.categoriapai = categoriaPai.descricao;
                this.categoria.idcategoriapai = categoriaPai.idcategoria;
            } else {
                this.categoria.idcategoriapai = null;
                this.categoria = null;
            }
            this.canSelectCategoria = false;
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        saveCategoria () {
            if (this.validation.validate(this.categoria, this.$refs)) {
                this.isSaving = true;
                this.service.save(this.mapOnSave(this.categoria))
                    .then(body => {
                        if (body.content) {
                        let msg =
                            this.$t(this.categoria.idcategoria != null
                                    ? "msg-edit-sucesso-n"
                                    : "msg-save-sucesso-n", 
                                { n: this.$t("categoria") }
                            );
                            this.msgs.push(new Message("success", msg, true, false));
                            this.redirectToList(2);
                        } else {
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: this.categoria.idcategoriaerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: "ven-categoria-list"
                });
            }, time * 1000 + 50);
        },
        categoriaVazia(){
            return {
                idcategoria: 0,
                descricao: this.$t('nenhuma-associacao-generica').toUpperCase(),
                label: this.$t('nenhuma-associacao-generica').toUpperCase(),
                situacao: 1,
                categoriapai: this.$t('nenhuma-associacao-generica').toUpperCase(),
                idcategoriapai: 0
            }
        },
        mapOnSave (categoria) {
            return {
                idcategoriapai: !categoria.idcategoriapai || categoria.idcategoriapai == 0 
                    ? 0 
                    : categoria.idcategoriapai,
    
                categoriapai: !categoria.idcategoriapai || categoria.idcategoriapai == 0 
                    ? null
                    : categoria.categoriapai,
                idcategoriaerp: categoria.idcategoriaerp,
                idcategoria: categoria.idcategoria,
                descricao: categoria.descricao,
                situacao: categoria.situacao.id,
            }
        },
        mapItems(body) {
            return body.content ? body.content.map(m => {
                return {                    
                    idcategoria: m.idcategoria,
                    descricao: m.descricao,
                    label: m.idcategoria + ' - ' +m.descricao,
                    situacao: m.situacao,
                    categoriapai: m.categoriapai,
                    idcategoriapai: m.idcategoriapai
                }
            }) : [];
        },
    }
};
</script>

<style lang="scss" scoped>
$padding: 5px;

#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
        margin-bottom: 20px;

        .novo-categoria {
            position: relative;
            width: 100%;
            margin-bottom: 20px;
            padding-top: 0;

            > h1 {
                padding-top: 20px;
                margin-bottom: 40px;
            }

            .form-buttons {
                right: 0;
            }
        }
    }
}

</style>
